import { ErpA } from './ErpHtml';
import React from 'react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { Link } from 'react-router-dom';

export interface ErpDropdownItemProps {
  to?: string;
  href?: string;
  variant?: string;
  disabled?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent<any>) => void;
  children?: React.ReactNode;
}

const ErpDropdownItem: React.FC<ErpDropdownItemProps> = ({
  to,
  href,
  variant,
  disabled,
  className = '',
  onClick,
  children,
}) => {
  const isDanger = variant === 'danger' || variant === 'destructive';
  const combinedClass = `${isDanger ? 'text-destructive focus:text-destructive focus:bg-destructive/10' : ''} cursor-pointer ${className}`.trim();

  // `asChild` renders the Link/anchor itself, which has no `disabled` concept,
  // so navigation must be cancelled explicitly when the item is disabled.
  const handleNavigationClick = (e: React.MouseEvent<any>) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick?.(e);
  };

  if (to) {
    return (
      <DropdownMenuItem disabled={disabled} className={combinedClass} asChild>
        <Link to={to as any} onClick={handleNavigationClick}>{children}</Link>
      </DropdownMenuItem>
    );
  }

  if (href) {
    return (
      <DropdownMenuItem disabled={disabled} className={combinedClass} asChild>
        <ErpA href={href} onClick={handleNavigationClick}>{children}</ErpA>
      </DropdownMenuItem>
    );
  }

  return (
    <DropdownMenuItem disabled={disabled} className={combinedClass} onClick={onClick}>
      {children}
    </DropdownMenuItem>
  );
};

export default ErpDropdownItem;
